__turbopack_context__.v({
  "grid": "PlpProductGrid-module-scss-module__By47nW__grid",
  "grid__cell": "PlpProductGrid-module-scss-module__By47nW__grid__cell",
  "grid__empty": "PlpProductGrid-module-scss-module__By47nW__grid__empty",
});
